import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { OrganicMobCorpse } from "./organicMobCorpse";

export class BiterCorpse extends OrganicMobCorpse {
	static key = "BiterCorpse";
	constructor(xy: XY) {
		super(xy);
	}

	static deserialize(data: any): BiterCorpse {
		const c = new BiterCorpse(deserializeXY(data.xy));
		c.restoreBaseFields(data);
		return c;
	}
}
